import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class VideoBtn extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            userData: this.props.userData,
            object: this.props.object,
            activeObject: this.props.activeObject,
            enabledObjects: this.props.enabledObjects,
            completeObjects: this.props.completeObjects,
            focusedObject: this.props.focusedObject,
            className: "",
            locale: appHelper.getLocalData(this.props.object),
            update: false,
            video: {
                src: "",
                thumbnail: ""
            },
        };
        this.setClass = this.setClass.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.onClicked = this.onClicked.bind(this);
        this.objectIsEnabled = this.objectIsEnabled.bind(this);
        this.objectIsComplete = this.objectIsComplete.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);

    }

    componentDidMount() {
        this.setClass();
        this.getAssets();
    }

    componentWillReceiveProps(nextProps) {

        if (this.state.object !== nextProps.object) {
            this.setState({object: Object.assign({}, nextProps.object)});
        }

        if (this.state.userData !== nextProps.userData) {
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }

        if (this.state.activeObject !== nextProps.activeObject) {
            this.setState({activeObject: Object.assign({}, nextProps.activeObject)});
        }
        if (this.state.enabledObjects !== nextProps.enabledObjects) {
            this.setState({enabledObjects: Object.assign([], nextProps.enabledObjects)});
        }
        if (this.state.completeObjects !== nextProps.completeObjects) {
            this.setState({completeObjects: Object.assign([], nextProps.completeObjects)});
        }

        if (this.state.focusedObject !== nextProps.focusedObject) {
            this.setState({focusedObject: Object.assign([], nextProps.focusedObject)});
        }

        if(this.state.lang !== nextProps.lang){
            let video = appHelper.getVideoAsset(this.props.object);
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screen),
                video: appHelper.isDefined(video) && video.src.length > 0 ? video : this.state.video
            });
        }
    }

    componentDidUpdate() {
        if (this.state.update) {
            this.setClass();
        }
    }

    getAssets() {
        let video = appHelper.getVideoAsset(this.props.object);
        video = appHelper.getLocalData(video);
        if (appHelper.isDefined(video) && video.src.length > 0) {
            this.setState({video: video});
        }
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    getObjectStatus(){
        let objectUserData = {};
        let subScreenParent = this.props.callbacks.getSubScreenParent();
        let screen_id = this.props.callbacks.getScreenId();
        if (appHelper.isDefined(subScreenParent)) {
            objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.object.asset_id);
        } else if (this.state.isResourceObject) {
            objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.object.asset_id);
        } else {
            objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.object.asset_id);
        }

        return objectUserData.status;

    }
    objectIsEnabled() {
        return appHelper.getArrayObjectIndexByKey(this.state.enabledObjects, "asset_id", this.state.object.asset_id);
    }

    objectIsComplete() {
        return appHelper.getArrayObjectIndexByKey(this.state.completeObjects, "asset_id", this.state.object.asset_id);
    }


    setClass() {
        let className = "";

        if (appHelper.isDefined(this.state.activeObject.data) && this.state.activeObject.data.asset_id === this.state.object.asset_id) {
            className += "active ";
        }

        if (this.objectIsEnabled() === -1) {
            className += "disabled ";
        }

        if (this.objectIsComplete() > -1 || this.getObjectStatus() === objectConstants.STATUS_COMPLETE) {
            className += "complete ";
        } else {
            className += "incomplete ";
        }

        if(this.state.focusedObject.asset_id === this.state.object.asset_id){

            className += "focused ";
        } else {
            className += "not-focused ";
        }

        return className;
    }

    onClicked() {
        if (this.objectIsEnabled() > -1 ||  this.getObjectStatus() === objectConstants.STATUS_COMPLETE) {
            this.props.onClickFunc(this.state.object);
        }
    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.onClicked();
        }
    }

    render() {
        return (
            <div className={`video-btn ${this.setClass()}`} onClick={this.onClicked} onKeyDown={this.setKeyboardAccessibility} role="presentation"  aria-current={appHelper.isDefined(this.state.activeObject.data) && this.state.activeObject.data.asset_id === this.state.object.asset_id} aria-disabled={this.objectIsEnabled() === -1}>
                <img src={this.getImagePath(this.state.video.thumbnail)} alt=""/>
            </div>
        );

    }
}

VideoBtn.propTypes = {
    object: PropTypes.object.isRequired,
    activeObject: PropTypes.object.isRequired,
    enabledObjects: PropTypes.array.isRequired,
    completeObjects: PropTypes.array.isRequired,
    callbacks: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    onClickFunc: PropTypes.func,
    focusedObject: PropTypes.object,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

VideoBtn.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VideoBtn);



/** WEBPACK FOOTER **
 ** ./src/components/screens/videoScreen/VideoBtn.js
 **/